import { render } from "./CounterBox.vue?vue&type=template&id=0bd11ee3&scoped=true"
import script from "./CounterBox.vue?vue&type=script&lang=js"
export * from "./CounterBox.vue?vue&type=script&lang=js"

import "./CounterBox.vue?vue&type=style&index=0&id=0bd11ee3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd11ee3"]])

export default __exports__